import { ClientHostType } from '@/types';


export const channel = (set) => {
    return {
        channel: ClientHostType.none,
        setChannel: (next: ClientHostType) => {
            console.log('[dev]看看-setChannelnext', next);
            set(() => ({
                channel: next,
            }));
        },
    };
};
